import { defineComponent, h } from 'vue';
import './VRow.scss';

export default defineComponent({
  name: 'VRow',
  render() {
    return h('div', { class: 'row' }, this.$slots.default?.());
  },
});
